import { showModal } from "app/modules/modal-management/reducer/action";
import React from "react";
import { useIdleTimer } from "react-idle-timer";
import { useDispatch } from "react-redux";

const useLogout = () => {
  const [minuteTimeout] = React.useState(5);
  const dispatchStore = useDispatch();

  const handleOnIdle = () => {
    dispatchStore(
      showModal({
        modalProps: {
          open: true,
        },
        modalType: "expiredAlert",
      }),
    );
  };

  useIdleTimer({
    crossTab: {
      emitOnAllTabs: true,
    },
    timeout: 1000 * 60 * minuteTimeout,
    startOnMount: true,
    onIdle: handleOnIdle,
    debounce: 500,
  });
};

export default useLogout;
